// redux/slices/credits.js

const { createSlice } = require('@reduxjs/toolkit');

const initialState = {
  credits: {
    data: [],
    error: null,
    loading: false,
    totalCount: 0,
    tableParams: {
      page: 0,
      size: 10,
    },
  },
  credit: { data: null, error: null, loading: false },
  createdCredit: { data: null, error: null, loading: false },
  removedCredit: { data: null, error: null, loading: false },
  editedCredit: { data: null, error: null, loading: false },
};

const { actions, reducer } = createSlice({
  name: 'credits',
  initialState,
  reducers: {
    createCredit: (state) => {
      state.createdCredit = { ...state.createdCredit, error: null, loading: true };
    },
    createCreditFailure: (state, { payload }) => {
      state.createdCredit = { ...state.createdCredit, error: payload, loading: false };
    },
    createCreditSuccess: (state, { payload }) => {
      state.createdCredit = { ...state.createdCredit, data: payload, error: null, loading: false };
    },
    getCredits: (state, { payload }) => {
      const { saveConfig = true, ...restPayload } = payload;
      state.credits = {
        ...state.credits,
        ...(saveConfig ? { tableParams: restPayload } : {}),
        error: null,
        loading: true,
      };
    },
    getCreditsFailure: (state, { payload }) => {
      state.credits = { ...state.credits, error: payload, loading: false };
    },
    getCreditsSuccess: (state, { payload }) => {
      state.credits = { ...state.credits, data: payload, error: null, loading: false };
    },
    getCreditById: (state) => {
      state.credit = { ...state.credit, error: null, loading: true };
    },
    getCreditByIdFailure: (state, { payload }) => {
      state.credit = { ...state.credit, error: payload, loading: false };
    },
    getCreditByIdSuccess: (state, { payload }) => {
      state.credit = { ...state.credit, data: payload, error: null, loading: false };
    },
    removeCredit: (state) => {
      state.removedCredit = { ...state.removedCredit, error: null, loading: true };
    },
    removeCreditFailure: (state, { payload }) => {
      state.removedCredit = { ...state.removedCredit, error: payload, loading: false };
    },
    removeCreditSuccess: (state, { payload }) => {
      state.removedCredit = { ...state.removedCredit, data: payload, error: null, loading: false };
    },
    updateCredit: (state) => {
      state.editedCredit = { ...state.editedCredit, error: null, loading: true };
    },
    updateCreditFailure: (state, { payload }) => {
      state.editedCredit = { ...state.editedCredit, error: payload, loading: false };
    },
    updateCreditSuccess: (state, { payload }) => {
      state.editedCredit = { ...state.editedCredit, data: payload, error: null, loading: false };
    },
  },
});

export const {
  createCredit,
  createCreditFailure,
  createCreditSuccess,
  getCredits,
  getCreditsFailure,
  getCreditsSuccess,
  getCreditById,
  getCreditByIdFailure,
  getCreditByIdSuccess,
  removeCredit,
  removeCreditFailure,
  removeCreditSuccess,
  updateCredit,
  updateCreditFailure,
  updateCreditSuccess,
} = actions;

export { default as creditsSaga } from './saga';
export default reducer;